
/* injects from baggage-loader */

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.plugins.setLang( 'colortext', 'ru', {
	auto: 'Автоматически',
	bgColorTitle: 'Цвет фона',
	colors: {
		'000': 'Чёрный',
		'800000': 'Бордовый',
		'8B4513': 'Кожано-коричневый',
		'2F4F4F': 'Темный синевато-серый',
		'008080': 'Сине-зелёный',
		'000080': 'Тёмно-синий',
		'4B0082': 'Индиго',
		'696969': 'Тёмно-серый',
		B22222: 'Кирпичный',
		A52A2A: 'Коричневый',
		DAA520: 'Золотисто-берёзовый',
		'006400': 'Темно-зелёный',
		'40E0D0': 'Бирюзовый',
		'0000CD': 'Умеренно синий',
		'800080': 'Пурпурный',
		'808080': 'Серый',
		F00: 'Красный',
		FF8C00: 'Темно-оранжевый',
		FFD700: 'Золотистый',
		'008000': 'Зелёный',
		'0FF': 'Васильковый',
		'00F': 'Синий',
		EE82EE: 'Фиолетовый',
		A9A9A9: 'Тускло-серый',
		FFA07A: 'Светло-лососевый',
		FFA500: 'Оранжевый',
		FFFF00: 'Жёлтый',
		'00FF00': 'Лайма',
		AFEEEE: 'Бледно-синий',
		ADD8E6: 'Свелто-голубой',
		DDA0DD: 'Сливовый',
		D3D3D3: 'Светло-серый',
		FFF0F5: 'Розово-лавандовый',
		FAEBD7: 'Античный белый',
		FFFFE0: 'Светло-жёлтый',
		F0FFF0: 'Медвяной росы',
		F0FFFF: 'Лазурный',
		F0F8FF: 'Бледно-голубой',
		E6E6FA: 'Лавандовый',
		FFF: 'Белый'
	},
	more: 'Ещё цвета...',
	panelTitle: 'Цвета',
	textColorTitle: 'Цвет текста'
} );



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/colortext/lang/ru.js